<template>
  <validation-observer ref="createDocument">
    <b-form
      @submit.prevent="handleSubmit"
      @keydown.enter="handleSubmit"
    >
      <!-- Información sobre subida masiva -->
      <b-alert
        show
        variant="info"
        class="mb-2"
      >
        <div class="alert-body">

          <span class="small">
            <feather-icon
                icon="InfoIcon"
                size="20"
            />
            La subida masiva permite cargar hasta <strong>200 archivos</strong> simultáneamente.
            Para asignar automáticamente cada documento a su operario correspondiente,
            el nombre del archivo debe incluir el <strong>DNI del operario</strong>
            (ejemplo: documento_12345678A.pdf).
          </span>
        </div>
      </b-alert>
      <!-- Sección Imagen/Avatar -->
      <b-row>
        <b-col :cols="12">
          <validation-provider
            #default="{ errors }"
            name="Nombre"
            rules="required"
          >
            <b-form-group
              label="Nombre"
              label-for="document-name"
            >
              <b-form-input
                v-model="name"
                name="name"
                placeholder="Nombre"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Archivos"
            label-for="document-file"
          >
            <FileDropzone
              ref="files"
              :files="files"
              label="Cargar archivo"
              max-files="200"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="mb-1"
        >
          <validation-provider
            #default="{ errors }"
            :name="'Categoría'"
            rules="required"
          >
            <b-form-group
              :label="'Categoría'"
              label-for="document-category"
            >
              <BaseSelect
                v-model="category"
                :searchable="true"
                :clearable="true"
                :multiple="false"
                :http-body="{
                  client_id: currentClient.id,
                  active: 1,
                }"
                :resource="'/document-categories'"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <div :class="showBackButton ? 'd-flex justify-content-between align-items-center' : 'text-right'">
        <b-button
          v-if="showBackButton"
          variant="outline-primary"
          @click="$emit('back')"
        >
          Volver
        </b-button>
        <b-button
          type="submit"
          variant="primary"
        >
          {{ 'Enviar' }}
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import FileDropzone from '@/components/elements/FileDropzone/FileDropzone.vue'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BAlert,
    FileDropzone,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BaseSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    showBackButton: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      publicDocument: 0,
      name: '',
      category: '',
      files: [],
    }
  },
  computed: {
    ...mapGetters({
      currentClient: 'clients/getCurrentClient',
    }),
  },
  methods: {
    ...mapActions({
      create: 'documents/createDocumentBulk',
    }),
    handleSubmit() {
      this.$refs.createDocument.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.create(formData)
          }
        }
      })
    },
    createFormData() {
      const data = this.$refs.files.getFormData('files')
      data.append('name', this.name)
      data.append('client_id', this.currentClient.id)
      data.append('category.id', this.category.id)

      return data
    },
  },
}
</script>
